import React, { Component } from 'react';
import { getCurrentFormattedDate } from '../../../../Utils/timeConvertorHelper';
import { millisecondTimeValues, timeValues, timeFormats } from '../../../../Constants/timeFormats';

export const withCurrentTime = WrappedComponent => {
    return class extends Component {
        state = {
            currentTime: getCurrentFormattedDate(timeFormats.INCOMPLETE_TIME),
        };

        componentDidMount() {
            const delay = this.calculateTimeLeftToMinuteEnd() * millisecondTimeValues.SECOND;
            this.secondsLeftTimeout = setTimeout(() => this.tickEveryMinute(), delay);
        }

        calculateTimeLeftToMinuteEnd = () => {
            const currentSeconds = getCurrentFormattedDate(timeFormats.SECONDS);
            return timeValues.MINUTE - currentSeconds;
        };

        tickEveryMinute = () => {
            this.setCurrentTime();
            this.everyMinuteInterval = setInterval(() => this.setCurrentTime(), millisecondTimeValues.MINUTE);
        };

        setCurrentTime = () => {
            const currentTime = getCurrentFormattedDate(timeFormats.INCOMPLETE_TIME);
            this.setState({ currentTime });
        };

        componentWillUnmount() {
            clearTimeout(this.secondsLeftTimeout);
            clearInterval(this.everyMinuteInterval);
        }

        render() {
            return <WrappedComponent currentTime={this.state.currentTime} {...this.props} />;
        }
    };
};



// WEBPACK FOOTER //
// ./src/UI/Containers/HOCS/withCurrentTime/index.js